// ABOUTME: Reusable three-state toggle component for filtering active, deleted, and all items
// ABOUTME: iOS-style segmented control for admin list views with soft delete functionality

import React from 'react';
import { Box, Button, ButtonGroup } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export type SoftDeleteFilter = 'active' | 'deleted' | 'all';

interface SoftDeleteToggleProps {
  value: SoftDeleteFilter;
  onChange: (value: SoftDeleteFilter) => void;
  disabled?: boolean;
}

const SoftDeleteToggle: React.FC<SoftDeleteToggleProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  const theme = useTheme();
  const options = [
    { value: 'active' as const, label: 'Active Only' },
    { value: 'deleted' as const, label: 'Deleted Only' },
    { value: 'all' as const, label: 'Show All' }
  ];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <ButtonGroup 
        variant="outlined" 
        size="small"
        disabled={disabled}
        sx={{
          '& .MuiButton-root': {
            minWidth: '100px',
            // fontSize matches the button variant's own baseline; not a Typography override
            fontSize: '0.875rem',
            textTransform: 'none',
            borderColor: theme.palette.divider,
            color: theme.palette.text.secondary
          },
          '& .MuiButton-root.selected': {
            backgroundColor: theme.palette.info.main,
            color: 'white',
            borderColor: theme.palette.info.main,
            '&:hover': {
              backgroundColor: theme.palette.info.dark,
              borderColor: theme.palette.info.dark
            }
          },
          '& .MuiButton-root:not(.selected):hover': {
            backgroundColor: theme.palette.grey[100],
            borderColor: theme.palette.divider
          }
        }}
      >
        {options.map((option) => (
          <Button
            key={option.value}
            onClick={() => onChange(option.value)}
            className={value === option.value ? 'selected' : ''}
            data-testid={`soft-delete-filter-${option.value}`}
          >
            {option.label}
          </Button>
        ))}
      </ButtonGroup>
    </Box>
  );
};

export default SoftDeleteToggle;